module.exports = "https://coursera_assets.s3.amazonaws.com/images/3e0e620a92d6a82889b19b8a33370952.png";